import tabConfig from './tabs'
import { hasPermission } from '~/modules/services/permission'

function TabBarController($rootScope, $location, tabService, storyService) {
  this.hasStoryId = () => {
    return this.storyObj._id || $location.path() === '/template'
  }

  this.editorTabs = tabConfig.filter((tab) => {
    if (tab.id === 'tab-circulate') {
      if ($location.path() === '/template') {
        return true
      } else {
        return hasPermission(window.userRolesAuth.story.circulate)
      }
    }

    return true
  })

  this.missingFields = tabConfig.reduce((acc, { settingsKey }) => {
    return settingsKey === null
      ? acc
      : {
          ...acc,
          [settingsKey]: false,
        }
  }, {})

  this.changeTab = (tab) => {
    if (!this.hasStoryId() && !$rootScope.globalSettings.permitTabsUnsaved) {
      const deregisterSaveCheck = $rootScope.$on(
        'LOG_USER_EVENT',
        (info, action) => {
          if (action.event.type === 'saveSuccess') {
            this.activeTab = tab.id
            tabService.set(tab.id)

            deregisterSaveCheck()
          } else if (action.event.type.indexOf('saveFailure') > -1) {
            deregisterSaveCheck()
          }
        }
      )

      storyService.save(true, false)
    } else {
      this.activeTab = tab.id
      tabService.set(tab.id)
      // $rootScope.$broadcast('CHANGE_TAB', {tab})
    }
  }

  $rootScope.$on('DISPATCH', (info, action) => {
    if (action.type === 'REQUIRED_FIELDS') {
      this.missingFields = action.fields.reduce(
        (acc, f) => {
          return {
            ...acc,
            [f.tab]: f.missing ? acc[f.tab] + 1 : acc[f.tab],
          }
        },
        { metas: 0, planning: 0, promo: 0 }
      )
    }
  })
}

export default [
  '$rootScope',
  '$location',
  'tabService',
  'storyService',
  TabBarController,
]
